import styled from 'styled-components';

export const Container = styled.aside`
  width: 480px;
  max-width: 50%;
  min-height: 0;

  .form-group {
    margin-bottom: 1.25rem;
  }

  label {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    margin-bottom: 0.35rem;
  }

  .task-section-title {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    margin-top: 1.75rem;
    margin-bottom: 0.5rem;
  }

  .task-new-body {
    overflow-y: auto;
  }

  .task-note {
    background: ${(props) => props.theme.$gray100};
  }

  .task-note-delete {
    color: ${(props) => props.theme.$danger};
    font-size: 12px;
  }

  .task-choice-text {
    max-width: 380px;
    line-height: 1.4;
  }

  .task-choice-hint {
    font-size: 13px;
  }

  .task-new-footer {
    position: sticky;
    bottom: 0;
    background: ${(props) => props.theme.$white};
  }

  .material-icons {
    font-size: 16px;
  }

  .notes-input-group .material-icons,
  .task-new-header .material-icons {
    font-size: 24px;
  }
`;
